import partnerPageSet from 'src/helpers/flows/pages/partner';
import { defaultPageSet } from 'src/helpers/flows/pageSets/default';
import { exclusivesPageSet } from 'src/helpers/flows/pageSets/exclusives';
import { FlowContext } from 'src/lib/flow';

import { untreatedRoomConditionPageSet } from './untreatedRoomCondition';

const allPageSets = {
  default: defaultPageSet,
  partners: partnerPageSet,
  exclusives: exclusivesPageSet,
  untreatedRoomCondition: untreatedRoomConditionPageSet,
};

/**
 * @returns The page set for the current flow context
 */
export const getPageSet = (pageSetName: string, context: FlowContext) => {
  if (pageSetName === 'partner') {
    return { pageSet: allPageSets.partners, name: pageSetName };
  }

  if (pageSetName === 'untreated_room_condition') {
    return { pageSet: allPageSets.untreatedRoomCondition, name: pageSetName };
  }

  // override the default flow and put the user in the exclusives flow when
  // they have an eligible exclusives product. Later if they get denied,
  // pageSetName will still be set to "exclusives" so the user will not be
  // kicked out of the exclusives flow
  if (
    pageSetName === 'exclusives' ||
    context.inputContext.eligibleProducts.includes('sell_with_exclusives')
  ) {
    return { pageSet: allPageSets.exclusives, name: 'exclusives' };
  }

  return { pageSet: allPageSets.default, name: 'default' };
};
